import EpgEvent from '../../../../../../shared/classes/epgEvent';
import List from '../../list';
import MediaProduction from '@shared/classes/mediaProduction';
import ProgressHorizontalCard from '../../../../elements/card/progressHorizontalCard';
import RailProps from '../../../../../../shared/types/props/rail';
import goToContent from '../../../../../../shared/actions/content/goToContent';
import useKeepWatchingUpdateEvents from '../../../../../../shared/components/utils/hooks/useKeepwatchingUpdateEvents';

function KeepWatchingRail({ list }: RailProps) {
  const { data, focus, setListIndex, deleteRail, onClick, updateData } = list;
  const eventsData = useKeepWatchingUpdateEvents({
    data: data as (EpgEvent | MediaProduction | undefined)[],
    setListIndex,
    deleteRail,
    updateData,
  });
  return (
    <List {...list}>
      {(eventsData as (EpgEvent | undefined)[])?.map(
        (item: EpgEvent | undefined, index: number) => {
          return (
            <ProgressHorizontalCard
              key={index}
              item={item as EpgEvent}
              index={index}
              onClick={() => onClick(item, index, focus)}
              releaseAction={() => goToContent(item)}
            />
          );
        }
      )}
    </List>
  );
}

export default KeepWatchingRail;
